import React, { Component } from "react";

class MemberDemographicsSVG extends React.Component {
  render() {
    return (
      <svg
        width="36"
        height="45"
        viewBox="0 0 36 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.4282 26.6194C8.43973 28.0846 4.78423 27.2735 3.30162 26.6194C1.7318 25.442 -0.538691 32.0638 0.115402 33.6336C0.638676 34.8895 3.08986 35.677 4.39804 35.9387C5.57541 31.6217 7.44429 29.6531 10.9764 27.1675L10.4282 26.6194Z"
          fill="#ED5C3C"
        />
        <path
          d="M3.50713 23.6918C4.45633 25.3924 10.2225 25.6975 9.67434 23.6918C9.54387 23.2144 9.33172 22.2343 9.33172 21.1379C9.33172 20.0415 9.33172 19.4933 9.67434 18.2256C9.96538 17.1488 10.4281 16.2041 10.7365 15.4503C11.2597 15.0579 7.31026 12.5722 4.17062 15.4502C1.65891 17.7526 2.46058 21.8167 3.50713 23.6918Z"
          fill="#ED5C3C"
        />
        <path
          d="M25.4578 26.6194C27.4462 28.0846 31.1017 27.2735 32.5843 26.6194C34.1541 25.442 36.4246 32.0638 35.7705 33.6336C35.2472 34.8895 32.7961 35.677 31.4879 35.9387C30.3105 31.6217 28.4416 29.6531 24.9095 27.1675L25.4578 26.6194Z"
          fill="#ED5C3C"
        />
        <path
          d="M32.3787 23.6918C31.4295 25.3924 25.6633 25.6975 26.2115 23.6918C26.3419 23.2144 26.5541 22.2343 26.5541 21.1379C26.5541 20.0415 26.5541 19.4933 26.2115 18.2256C25.9204 17.1488 25.4577 16.2041 25.1493 15.4503C24.6261 15.0579 28.5755 12.5722 31.7152 15.4502C34.2269 17.7526 33.4252 21.8167 32.3787 23.6918Z"
          fill="#ED5C3C"
        />
        <path
          d="M12.5739 29.2803C16.3415 32.6292 20.1407 31.7721 22.0593 30.3767L18.7202 43.932C17.2886 44.2501 13.7747 44.004 12.157 43.2779C9.51731 42.0931 7.05604 39.9787 6.16383 38.4376C6.05917 34.356 9.69593 29.9344 12.5739 29.2803Z"
          fill="#ED5C3C"
        />
        <path
          d="M23.3217 29.2803C19.5542 32.6292 15.755 31.7721 13.8364 30.3767L17.1755 43.932C18.6071 44.2501 22.121 44.004 23.7387 43.2779C26.3784 42.0931 28.8396 39.9787 29.7319 38.4376C29.8365 34.356 26.1998 29.9344 23.3217 29.2803Z"
          fill="#ED5C3C"
        />
        <path
          d="M17.9472 28.9748C23.4939 28.8702 24.2701 22.3031 23.9648 19.0326C23.7032 17.5064 22.1334 14.0615 17.9472 14.0615C13.7493 14.0615 12.1912 17.2448 11.9295 19.0326C11.6243 22.3903 12.4005 29.0795 17.9472 28.9748Z"
          fill="#ED5C3C"
        />
        <path
          d="M17.9387 28.9748C12.392 28.8702 11.6158 22.3031 11.921 19.0326C12.1827 17.5064 13.7525 14.0615 17.9387 14.0615C22.1366 14.0615 23.6947 17.2448 23.9564 19.0326C24.2616 22.3903 23.4854 29.0795 17.9387 28.9748Z"
          fill="#ED5C3C"
        />
        <rect
          width="5"
          height="9"
          transform="matrix(-1 0 0 1 31 3)"
          fill="#ED5C3C"
        />
        <rect
          width="5"
          height="7"
          transform="matrix(-1 0 0 1 10 5)"
          fill="#ED5C3C"
        />
        <rect
          width="5.48196"
          height="12.0603"
          transform="matrix(-1 0 0 1 20.6526 0)"
          fill="#ED5C3C"
        />
      </svg>
    );
  }
}

export default MemberDemographicsSVG;



// WEBPACK FOOTER //
// ./src/svg/MemberDemographicsSVG.jsx